export default __webpack_public_path__ + "static/media/close.cac8ca26.svg";